import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledCardCarousel = styled.div<{ variation: string }>`
  @media ${baseVariables.mediaQuery.xl} {
    display: ${props => (props.variation === 'combo' ? 'flex' : 'block')};
  }
  .aem-container:first-child {
    margin-left: 0;
  }
  .carousal_header {
    display: flex;
    flex-direction: ${props => (props.variation === 'combo' ? 'column' : ' row')};
    justify-content: ${props => (props.variation === 'combo' ? 'center' : ' space-between')};
    align-items: ${props => (props.variation === 'combo' ? 'flex-start' : ' unset')};
    width: auto;
    @media ${baseVariables.mediaQuery.md} {
      width: ${props => (props.variation === 'combo' ? 'auto' : 'auto')};
    }

    .carousal_header--cta {
      display: flex;
      align-items: ${props => (props.variation === 'combo' ? 'unset' : ' flex-end')};
      margin-right: ${props => (props.variation === 'combo' ? 0 : toRem(4))};
      text-wrap: nowrap;
    }
  }
  .glide {
    margin-left: 0 !important;
    &__track {
      padding-top: ${toRem(24)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .glide__slides > .cq-Editable-dom > .cq-Editable-dom--container {
      display: contents;
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .glide--swipeable {
    cursor: default;
  }

  /*
    Fixes z-index issue in Non-Desktop view where Explore Our Destinations
    carousel arrows overlapped the Search Form calendar pop-up.
  */
  @media ${baseVariables.mediaQuery.allTablets}, ${baseVariables.mediaQuery.mobile} {
    #cn-destinations-2 .glide__arrow {
      z-index: 1;
    }
  }

  .glide__arrow span {
    font-size: 24px;
  }

  .glide__slides {
    padding-left: 0 !important;
  }

  .glide .card-vertical .m-button-external:hover,
  .glide .card-vertical [class*='m-button'] {
    transition: none;
    padding-right: 16px;
    box-shadow: none;
    &::after {
      display: none;
    }
  }

  .carouselControlType1 {
    gap: 30px;

    .glide__arrow {
      font-size: 13px !important;
      line-height: 15px !important;
      padding: 0;
      gap: 0;
    }

    button.glide__arrow[class*='-disabled'] {
      cursor: not-allowed;
    }
  }
`;
